import { render } from "./DashboardSection.vue?vue&type=template&id=2afdf6b4&ts=true"
import script from "./DashboardSection.vue?vue&type=script&lang=ts"
export * from "./DashboardSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__